import React from "react";
import "../index.css"


const WishListProductData = (props) =>{
    const { product, cartItems, setCartItems, company, updateCartItems, handleWishListChange, pmCompanyConfig } = props
    const { eachProduct, relatedCartItem } = product

    if(!eachProduct){
        return <div></div>
    }

    const materialImages = eachProduct?.materialImage?.length > 0 ? eachProduct.materialImage : ["https://procmart-tech.s3.ap-south-1.amazonaws.com/app-images/no_image.png"]
    const materialImagesObjs = materialImages?.map(imageUrl => ({
        itemImageSrc: imageUrl,
    }))

    const materialImage = eachProduct.materialImage?.length > 0 ? eachProduct.materialImage[0] : "https://procmart-tech.s3.ap-south-1.amazonaws.com/app-images/no_image_no_pg+(6).png"

    const handleQuantityChange = (event, selectedItem) => {
        cartItems.map(eachCartItem => {
            if(eachCartItem.buyerRateContractId === selectedItem.buyerRateContractId){
                eachCartItem.quantity = event.target.value
            }
        })
        setCartItems([...cartItems])
    }

    return (
        <>
            <div className="buyer-portal-card-container">
                <div className="mt-4" style={{ paddingLeft: "12px", paddingRight: "12px" }}>
                    <div className="product-box-3 h-100 wow fadeInUp" data-wow-delay="0.3s">
                        <div className="product-header">
                            <div className="product-image" style={{display: "flex", justifyContent: "center", alignItems: "center"}} >
                                <img src={materialImage} className="product-card-img" style={{maxHeight: "120px", width: "auto", maxWidth: "180px"}} alt=""></img>
                                <div className="product-header-top">
                                    <button className="btn wishlist-button close_button" style={{color:" #4a5568", fontWeight: '400'}} onClick={() => handleWishListChange(eachProduct.buyerRateContractId)} >
                                        <i className="pi pi-times"></i>
                                    </button> 
                                </div>
                            </div>
                        </div>

                        <div className="product-footer">
                            <div className="product-detail buyer-portal-card-content">
                                <h5 className="mb-1 name" maxLength={20}>{eachProduct.companyProdName}</h5>
                                <div className='product-specification' style={{ marginTop: '0px' }}>
                                    <div className="span-name product-description">{eachProduct.companyProdSpec}</div>
                                </div>
                                <h6 className="my-2 unit">
                                    <span className="erp">ERP:&nbsp;</span><span>{eachProduct.companyERPCode}</span>
                                </h6>
                                <h6 className="my-2 unit">
                                    <span className="erp">Lead Time:&nbsp;</span><span>{eachProduct.leadTime}</span>
                                </h6>
                                <h6 className="my-2 unit">
                                    <span className="erp">{pmCompanyConfig.GSTRateLabel}:&nbsp;</span><span>{eachProduct.companyGSTOverride} (%)</span>
                                </h6>
                                <div className="flex justify-content-between">
                                    <p className="my-2 price">
                                        <span className="theme-color">{pmCompanyConfig.currencySymbol} {eachProduct.unitPrice}</span>
                                    </p>
                                    <p className="my-2 product-description unit">
                                        {eachProduct.companyERPUOM ? <>Unit: <span>{eachProduct.companyERPUOM}</span></> : ""}
                                    </p>
                                </div>

                                { company?.tags?.canAddRateContract ? 
                                    <div className="add-to-cart-box bg-white">
                                        {
                                        !relatedCartItem || (relatedCartItem && relatedCartItem.quantity === 0) ?
                                            <button className="btn btn-add-cart addcart-button" onClick={() => updateCartItems("ADD", eachProduct)} >Add
                                                <span className="add-icon bg-light-gray">
                                                    <i className="fa-solid fa-plus"></i>
                                                </span>
                                            </button>
                                            :
                                            <>
                                                <button className="btn btn-add-cart addcart-button">Add
                                                    <span className="add-icon bg-light-gray">
                                                        <i className="fa-solid fa-plus"></i>
                                                    </span>
                                                </button>
                                                <div className="cart_qty qty-box">
                                                    <div className="input-group flex bg-white">
                                                        <button type="button" className="qty-left-minus bg-gray"
                                                            data-type="minus" data-field="" onClick={() => updateCartItems("DECREASE", relatedCartItem)} >
                                                            <i className="fa fa-minus"></i>
                                                        </button>
                                                        <input
                                                            className="form-control input-number qty-input"
                                                            type="text"
                                                            name="quantity"
                                                            placeholder="Quantity"
                                                            value={relatedCartItem.quantity}
                                                            onChange={(e) => handleQuantityChange(e, relatedCartItem)}
                                                            onBlur={() => updateCartItems("SET", relatedCartItem)}
                                                        >
                                                        </input>
                                                        <button type="button" className="qty-right-plus bg-gray"
                                                            data-type="plus" data-field="" onClick={() => updateCartItems("INCREASE", relatedCartItem)}>
                                                            <i className="fa fa-plus"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div> : ""
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default WishListProductData;